// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";

function getCurrentCityData(all_cities, current_city) {
  return Js_array.find((function (city) {
                return city.city_name.toLocaleLowerCase() === current_city.toLocaleLowerCase();
              }), all_cities);
}

var arrow_icon = {
  src: "https://nest-platform-assets.porter.in/right_arrow_13ec096466/right_arrow_13ec096466.svg",
  width: 24.0,
  height: 24.0,
  alt: "arrow icon"
};

export {
  getCurrentCityData ,
  arrow_icon ,
}
/* No side effect */
